import { notify } from "@portal/BaseComponents/Notifications";
import {
  createAContact,
  deleteAContact,
  getContactTypes,
  updateAContact,
} from "@portal/api/contacts";
import {
  Contact_LV_UI_DTO,
  CreateContact,
} from "@portal/types/entities/contact";
import { useMutation, useQuery } from "@tanstack/react-query";

interface ContactsParams {
  onSuccessCallBack?: (data?: Contact_LV_UI_DTO) => void;
  id?: string;
}
function useUpdateContactQuery(params: ContactsParams) {
  const { onSuccessCallBack, id } = params;
  return useMutation({
    mutationKey: ["update-contacts"],
    mutationFn: (data: CreateContact) => updateAContact(data, id),
    onSuccess(data) {
      onSuccessCallBack?.(data);
    },
    onError() {
      notify.error("Failed to update contacts. Please try again later.");
    },
  });
}
function useCreateContactQuery(params: ContactsParams) {
  const { onSuccessCallBack } = params;
  return useMutation({
    mutationKey: ["create-contacts"],
    mutationFn: (data: CreateContact) => createAContact(data),
    onSuccess(data) {
      onSuccessCallBack?.(data);
      notify.success("Contact Created");
    },
    onError() {
      notify.error("Failed to create contact. Please try again later.");
    },
  });
}
function useDeleteContactQuery(params: ContactsParams) {
  const { onSuccessCallBack, id } = params;

  return useMutation({
    mutationKey: ["delete-a-contact"],
    mutationFn: () => deleteAContact(id),
    onSuccess(data) {
      onSuccessCallBack?.();
    },
    onError() {
      notify.error("Failed to delete contact. Please try again later.");
    },
  });
}

function useGetContactTypes() {
  return useQuery({
    queryKey: ["contact-types"],
    queryFn: () => getContactTypes(),
  });
}
export {
  useCreateContactQuery,
  useDeleteContactQuery,
  useUpdateContactQuery,
  useGetContactTypes,
};
